import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import Link from "@shared/components/contents/link/Link";
import React from "react";
import { usePageVersion } from "@frontoffice/hooks/PageVersionHook";
import useGlobalStore from "@shared/store/GlobalStore";
import LinkEditor from "@administration/components/editor/LinkEditor";
import NavigationGroup from "./NavigationGroup";
export const styleMenuItemLink = {
    fontFamily: '"Montserrat"',
    whiteSpace: "nowrap",
    color: "primary.contrastText",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    textDecoration: "none",
    fontSize: "15px",
    "& .NavigationItem-label": {
        position: "relative",
        "&::after": {
            content: '""',
            position: "absolute",
            right: 0,
            bottom: "-3px",
            left: 0,
            height: "1px",
            backgroundColor: "currentColor",
            transform: "scaleX(0)",
            transformOrigin: "left",
            transition: "transform 200ms ease",
        },
    },
    "&:hover, &:focus-visible": {
        textDecoration: "none",
        "& .NavigationItem-label::after": {
            transform: "scaleX(1)",
        },
    },
};
export const capitalizeFirstLetter = (string) => {
    return string?.charAt(0).toUpperCase() + string?.slice(1);
};
const NavigationLink = ({ menuItem = {}, depth = 0, ...others }) => {
    const { isBo } = useGlobalStore((state) => ({ isBo: state.isBo }));
    const { currentPageVersion } = usePageVersion({ enabled: !isBo });
    const { title, subtext = "", link = {} } = menuItem;
    const isActive = React.useMemo(() => {
        const { page } = link || {};
        const { fullPath } = page || {};
        if (currentPageVersion && fullPath) {
            if (fullPath === "/") {
                return currentPageVersion["fullPath"] === fullPath;
            }
            if (currentPageVersion["fullPath"]) {
                return currentPageVersion["fullPath"].startsWith(fullPath);
            }
        }
        return false;
    }, [link, currentPageVersion]);
    const LinkRender = isBo ? LinkEditor : Link;
    return (_jsx(LinkRender, { ...others, sx: {
            ...styleMenuItemLink,
            ...(isActive && depth === 0
                ? {
                    fontWeight: 700,
                    "& .NavigationItem-label::after": {
                        transform: "scaleX(1)",
                    },
                }
                : {}),
            ...others.sx,
        }, ...link, variant: "subtitle1", children: _jsxs(Stack, { spacing: 0, alignItems: "flex-start", children: [_jsx("span", { className: "NavigationItem-label", children: capitalizeFirstLetter(title) }), subtext && (_jsx(Typography, { component: "span", variant: "body2", color: "text.secondary", sx: {
                        fontSize: { xs: "11px !important", md: "13px !important" },
                        fontWeight: 400,
                        mt: "2px",
                    }, children: capitalizeFirstLetter(subtext) }))] }) }));
};
const NavigationItem = ({ menuItem, ...others }) => {
    const subMenus = React.useMemo(() => {
        if (menuItem?.subMenus) {
            return Array.isArray(menuItem.subMenus)
                ? menuItem.subMenus
                : [menuItem.subMenus];
        }
        return [];
    }, [menuItem]);
    if (subMenus.length) {
        return (_jsx(NavigationGroup, { menuItem: menuItem, subMenus: subMenus, ...others }));
    }
    return _jsx(NavigationLink, { menuItem: menuItem, ...others });
};
export default NavigationItem;
